import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import { registerAccountSetupStep as registerLocales } from 'globals/locales/registration';
import { FsRegisterAccountSetupFormDataFormProps } from 'ui-elements/forms/FsRegisterAccountSetupForm/FsRegisterAccountSetupForm';
import FsRegisterAccountSetupForm from 'ui-elements/forms/FsRegisterAccountSetupForm';
import {
  FsCounterBox,
  FsHello,
  FsHelloWrapperBox,
  FsCenterBoxLine,
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import { WrapperBox } from './RegisterAccountSetupStep.style-elements';
import { RegisterStepProps } from '../Steps.types';

interface RegisterAccountSetupStepProps extends RegisterStepProps {
  onGoNext?: (props?: FsRegisterAccountSetupFormDataFormProps) => void;
}

const RegisterAccountSetupStep: React.FC<RegisterAccountSetupStepProps> = ({
  stepIndex,
  stepsLength,
  onGoNext,
}) => {
  const [formDefaults] = useState<FsRegisterAccountSetupFormDataFormProps>({
    firstName: '',
    lastName: '',
    companyName: '',
    password: '',
    repeatPassword: '',
  });

  return (
    <WrapperBox>
      <FsHelloWrapperBox>
        <FsHello>{registerLocales.hello}</FsHello>
        <FsCounterBox>
          <i>{stepIndex}</i>/{stepsLength}
        </FsCounterBox>
      </FsHelloWrapperBox>
      <FsCenterBoxTitle>{registerLocales.title}</FsCenterBoxTitle>
      <FsCenterBoxSubTitle>{registerLocales.subTitle}</FsCenterBoxSubTitle>
      <FsCenterBoxLine />
      <Box marginTop={3}>
        <FsRegisterAccountSetupForm {...formDefaults} onGoNext={onGoNext} />
      </Box>
    </WrapperBox>
  );
};

export default RegisterAccountSetupStep;
